export default {"src":"/_next/static/media/togglhire-purple.a589be6a.svg","height":17,"width":74,"blurWidth":0,"blurHeight":0};